export default __webpack_public_path__ + "static/media/Comp 2_00018.7fe935c9.png";